
/**
 * Frontend view script for Social Share Block.
 *
 * Builds share URLs from the page's canonical URL (Yoast / RankMath / generic)
 * or falls back to window.location.href.
 */

( function () {
	'use strict';

	function getCanonicalUrl() {
		var link = document.querySelector( 'link[rel="canonical"]' );
		if ( link && link.href ) {
			return link.href;
		}

		var ogUrl = document.querySelector( 'meta[property="og:url"]' );
		if ( ogUrl && ogUrl.content ) {
			return ogUrl.content;
		}

		return window.location.href;
	}

	function getPageTitle() {
		var ogTitle = document.querySelector( 'meta[property="og:title"]' );
		if ( ogTitle && ogTitle.content ) {
			return ogTitle.content;
		}
		return document.title || '';
	}

	function buildShareUrl( network, pageUrl, pageTitle ) {
		var encoded = encodeURIComponent( pageUrl );
		var encodedTitle = encodeURIComponent( pageTitle );

		switch ( network ) {
			case 'facebook':
				return 'https://www.facebook.com/sharer/sharer.php?u=' + encoded;
			case 'x':
				return 'https://x.com/intent/post?url=' + encoded + '&text=' + encodedTitle;
			case 'linkedin':
				return 'https://www.linkedin.com/shareArticle?url=' + encoded;
			case 'whatsapp':
				return 'https://api.whatsapp.com/send?text=' + encodedTitle + '%20' + encoded;
			case 'pinterest':
				return 'https://pinterest.com/pin/create/button/?url=' + encoded + '&description=' + encodedTitle;
			default:
				return '#';
		}
	}

	function init() {
		var blocks = document.querySelectorAll( '.wp-block-machete-machete-share-block' );

		if ( ! blocks.length ) {
			return;
		}

		var pageUrl = getCanonicalUrl();
		var pageTitle = getPageTitle();

		blocks.forEach( function ( block ) {
			var links = block.querySelectorAll( 'a.machete-share-block__button[data-network]' );

			links.forEach( function ( link ) {
				var network = link.getAttribute( 'data-network' );
				link.href = buildShareUrl( network, pageUrl, pageTitle );
			} );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
